import { Link } from "react-router-dom";

import { usePageTitle } from "@/hooks/usePageTitle";

export function NotFound(): JSX.Element {
  usePageTitle("Page not found");
  return (
    <main className="min-h-full flex items-center justify-center px-4">
      <div className="card max-w-sm w-full space-y-4 text-center">
        <h1 className="text-xl font-semibold">Page not found</h1>
        <p className="text-sm text-ink-300">
          There&apos;s nothing at this address — the link may be outdated or mistyped.
        </p>
        <Link to="/" className="btn-primary w-full">
          Go to your dashboard
        </Link>
      </div>
    </main>
  );
}
